import styled from 'styled-components';

export const PageDescription = styled.p`
  font-size: 16px;
  color: #444444;
  font-weight: 400;
  line-height: 30px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;
